import React from 'react';

import classNames from 'classnames';

import { TypeDecorativeDividerFields } from '@/core/generated-types';

import {
  TW_DECORATIVE_DIVIDER_MARGIN_BOTTOM_CLASSES,
  TW_DECORATIVE_DIVIDER_MARGIN_TOP_CLASSES,
} from '@/core/constants';

export const imageParams = '?fm=webp&q=75';

interface DecorativeDividerProps extends TypeDecorativeDividerFields {
  isHidden?: boolean;
  isSimpleLayout?: boolean;
}

const DecorativeDivider = ({
  entryName,
  height = 48,
  backgroundColor,
  dividerImage,
  cropped = false,
  isFullWidth = true,
  id,
  reversed,
  marginTop = '0',
  marginBottom = '0',
  isHidden,
  isSimpleLayout = false,
}: DecorativeDividerProps) => {
  if (isHidden) {
    return null;
  }

  const wrapperClasses = classNames(
    'bg-transparent',
    TW_DECORATIVE_DIVIDER_MARGIN_TOP_CLASSES[marginTop],
    TW_DECORATIVE_DIVIDER_MARGIN_BOTTOM_CLASSES[marginBottom],
    {
      'h-6': isSimpleLayout,
      'h-3.5 lg:h-6': !isSimpleLayout && height === 24,
      'h-5 lg:h-10': !isSimpleLayout && height === 40,
      'h-6 lg:h-12': !isSimpleLayout && height === 48,
      'h-8 lg:h-16': !isSimpleLayout && height === 64,
    },
  );

  const dividerClasses = classNames(
    'h-full m-0 bg-cover lg:bg-contain',
    {
      'bg-[position:0_-1rem]': cropped,
      'bg-center': !cropped,
      'w-full': isFullWidth,
      'w-[80%]': !isFullWidth,
      'bg-repeat-x': !isSimpleLayout,
      'rotate-180': reversed,
    },
    backgroundColor && `bg-${backgroundColor.fields?.color}`,
  );

  return (
    <div
      className={wrapperClasses}
      data-testid={`decorative-divider-${entryName}`}
    >
      <div
        className={dividerClasses}
        id={id}
        data-testid={id}
        style={{
          backgroundImage: `url(https:${dividerImage?.fields?.Image?.fields?.file?.url}${imageParams})`,
        }}
      ></div>
    </div>
  );
};

export default React.memo(DecorativeDivider);
